"use client";

import React, { useState } from "react";
import { HiMiniLanguage } from "react-icons/hi2";

import filled from "../../assets/course-details/blueStar.svg";
import unfilled from "../../assets/course-details/blueStarUn.svg";
import langLogo from "../../assets/course-details/langLogo.svg";
import syllabusLogo from "../../assets/course-details/syllabus_logo.svg";
import languageIcon from "../../assets/language.svg";
import usersIcon from "../../assets/users.svg";
// import popupImage from "../../assets/course-details/pop-up/pop-up-1.png";

// import PopUp from "../popup/PopUp";

const TopHighlight = ({ data, universityData }) => {
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;
  const review = [filled, filled, filled, filled, unfilled];

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showExpertBox, setShowExpertBox] = useState(true);
  const [showExpertPanel, setShowExpertPanel] = useState(false);

  const handleButtonClick = () => {
    setIsPopUpOpen(true);
  };

  const handleClosePopUp = () => {
    setIsPopUpOpen(false);
  };

  // Helper to extract YouTube video ID
  const getYouTubeId = (url) => {
    const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url?.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  };
  const videoId = getYouTubeId(universityData?.video);
  const videoThumbnail = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : null;
  const videoUrl = videoId ? `https://www.youtube.com/watch?v=${videoId}` : universityData?.video;

  return (
    <div className="bg-gradient-to-b from-[#f7faff] to-[#eaf0ff] shadow-sm py-10 md:py-16">
      <div className="mx-auto flex flex-col md:flex-row px-4 md:px-16 gap-8 max-w-[1400px]">
        <div className="flex flex-col items-start w-full md:w-1/2">
          <div className="flex items-center gap-4 mb-2">
            <img
              src={`${IMAGE_BASE}/${universityData?.logo}`}
              alt={data.programName}
              className="w-auto h-10 md:h-14 object-contain"
            />
            <span className="text-2xl md:text-3xl font-bold leading-tight text-[#262626] tracking-wide">
              {universityData?.name}
            </span>
          </div>
          <h1 className="py-2 md:py-3 text-2xl md:text-3xl font-bold leading-tight text-[#262626]">
            {data.programName}
          </h1>
          <p className="text-base md:text-lg leading-6 text-[#262626] mb-4">{data.description}</p>
          {/* Rating, Stars, and Reviews in one line, left-aligned */}
          <div className="flex items-center gap-2 my-4">
            <p className="text-[#262626] font-semibold text-base md:text-lg">4.0</p>
            <div className="flex items-center">
              {review.map((image, index) => (
                <img
                  src={image}
                  key={index}
                  height={20}
                  alt="Star"
                  className="mx-[2px]"
                />
              ))}
            </div>
            <p className="text-sm text-[#737373] ml-2">(300 Reviews)</p>
          </div>
          {/* Language and Taught in English */}
          <div className="flex items-center mb-3 mt-2">
            <img src={languageIcon} alt="Language" className="w-5 h-5 mr-2" />
            <span className="text-base md:text-lg text-[#262626]">Taught in English</span>
          </div>
          {/* Buttons */}
          <div className="flex flex-row gap-4 mb-3">
            <button className="h-11 w-[160px] text-primary-color font-semibold border border-primary-color rounded-md flex items-center justify-center gap-2 text-base md:text-lg">
              <img src={syllabusLogo} alt="Download Syllabus" className="w-5 h-5" />
              Syllabus
            </button>
            <button
              className="h-11 w-[160px] text-white bg-primary-color font-semibold border-none rounded-md shadow-md text-base md:text-lg"

              onClick={handleButtonClick}
            >
              Enquire Now
            </button>
          </div>
          {/* Already Engaged */}
          <p className="mt-1 text-base md:text-lg text-[#262626] font-medium">
            <span className="font-bold">875</span> Already Engaged
          </p>
          {/* Enquiry Call Section */}
          <div className="flex items-center mt-3 mb-1 text-base md:text-lg text-[#262626]">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="#04236B" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M22 16.92v3a2 2 0 0 1-2.18 2A19.72 19.72 0 0 1 3.08 5.18 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.72c.13 1.05.37 2.07.72 3.05a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a2 2 0 0 1 2.11-.45c.98.35 2 .59 3.05.72A2 2 0 0 1 22 16.92z" /></svg>
            For Enquiries Call: <span className="font-bold ml-1">1800202020</span>
          </div>
        </div>
        <div className="flex items-start justify-end w-full md:w-1/2 mt-0 md:mt-0">
          {/* Custom video thumbnail with play button overlay */}
          {videoThumbnail ? (
            <div className="relative w-full md:w-[417px] h-[200px] md:h-[265px] flex items-center justify-center cursor-pointer group" onClick={() => window.open(videoUrl, '_blank')}>
              <img src={videoThumbnail} alt="Course Video" className="w-full h-full object-cover rounded-xl shadow-md" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white bg-opacity-80 rounded-full p-4 shadow-lg group-hover:scale-110 transition-transform">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="24" fill="#04236B" fillOpacity="0.85" />
                    <polygon points="20,16 36,24 20,32" fill="#fff" />
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full md:w-[417px] h-[200px] md:h-[265px] bg-gray-200 flex items-center justify-center rounded-xl">No Video</div>
          )}
        </div>
      </div>
      {/* Floating Talk To An Expert Box */}
      {showExpertBox && (
        <div className={`fixed right-8 bottom-8 flex flex-col items-end z-50`}>
          {!showExpertPanel && (
            <div className="flex items-center bg-white rounded-lg shadow-lg px-4 py-2 mb-2">
              <span className="text-base font-medium mr-2">Talk To An <span className="text-[#FF9900]">Expert?</span></span>
              <button onClick={() => setShowExpertBox(false)} className="ml-2 text-gray-400 hover:text-gray-700">&times;</button>
            </div>
          )}
          {!showExpertPanel && (
            <button
              className="bg-white rounded-full shadow-lg p-2 flex items-center justify-center border border-[#FF9900] hover:scale-105 transition-transform"
              onClick={() => setShowExpertPanel(true)}
            >
              <img src={usersIcon} alt="User" className="w-8 h-8" />
            </button>
          )}
          {showExpertPanel && (
            <div className="mt-2 bg-white rounded-lg shadow-lg px-6 py-4 flex flex-col items-start min-w-[220px] relative animate-slide-in-right">
              <button onClick={() => setShowExpertPanel(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-700">&times;</button>
              <span className="text-base font-medium">Talk To An <span className="text-[#FF9900]">Expert?</span></span>
              {/* Add your expert chat or form here */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TopHighlight;

const StarRating = ({ rating }) => {
  const stars = Array.from({ length: 5 }, (_, index) => (
    <svg
      key={index}
      viewBox="0 0 576 512"
      width="100"
      title="star"
      className="h-5 w-5"
      fill="orange"
    >
      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
    </svg>
  ));

  return (
    <div className="flex items-center relative w-fit">
      <div
        className="bg-white h-full absolute overflow-hidden top-0 right-0 mix-blend-color"
        style={{ width: `${(1 - rating / 5) * 100}%` }}
      ></div>
      {stars}
    </div>
  );
};
